import script from "./IndustrySolutionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./IndustrySolutionsView.vue?vue&type=script&setup=true&lang=js"

import "./IndustrySolutionsView.vue?vue&type=style&index=0&id=1d20ebc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d20ebc8"]])

export default __exports__